const defaultEncryptionKey = process.env.REACT_APP_ENCRYPTION_KEY as string

const crypt = (data: string, encryptionKey: string) => {
  let crypted = ''
  for (var i = 0; i < data.length; i++) {
    crypted += String.fromCharCode(
      // tslint:disable-next-line: no-bitwise
      data.charCodeAt(i) ^ encryptionKey.charCodeAt(i % encryptionKey.length),
    )
  }
  return crypted
}

const asciiToHex = (data: string) => {
  for (var ath = '', i = 0; i < data.length - 1; i += 2) {
    ath += String.fromCharCode(parseInt(data.substr(i, 2), 16))
  }
  return ath
}

const hexToAscii = (data: string) => {
  for (var hta = '', i = 0; i < data.length; i++) {
    const z =
      '0' +
      data
        .charCodeAt(i)
        .toString(16)
        .toUpperCase()
    hta += z.substr(z.length - 2, 2)
  }
  return hta
}

const encryptService = () => {
  return {
    encrypt: (data: string, encryptionKey: string = defaultEncryptionKey) => {
      return hexToAscii(crypt(data, encryptionKey))
    },
    decrypt: (data: string, encryptionKey: string = defaultEncryptionKey) => {
      return crypt(asciiToHex(data), encryptionKey)
    },
  }
}

export default encryptService



// WEBPACK FOOTER //
// ./src/utils/services/encryptService.ts